import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-336d3abb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-2 w-2 shadow-md rounded-full absolute left-5 bg-blue-400"
}
const _hoisted_2 = { class: "flex gap-3 items-center text-sm overflow-hidden" }
const _hoisted_3 = { class: "ml-1 flex items-center gap-2" }
const _hoisted_4 = { class: "whitespace-nowrap flex-shrink-0 text-13 text-gray-theme-600" }
const _hoisted_5 = {
  key: 0,
  class: "h-4.5 w-4.5 rounded-full absolute top-0 bottom-0 left-0 right-0 bg-white bg-opacity-50 flex items-center justify-center"
}

import { computed, ref } from 'vue';
import {
	BaseConversation,
	useConversations,
	useMessages
} from '../../composition';
import ShortMessage from './ShortMessage.vue';
import UnreadMarker from './UnreadMarker.vue';
import {
	UiLoader,
	UiAvatar,
	Tooltip,
	SvgIcon,
	DropdownWithTooltip
} from '@/ui-kit';
import { useTeams } from '@/team';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationItem',
  props: {
    conversation: null,
    isOnFocus: { type: Boolean },
    isFocused: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
	conversation: BaseConversation;
	isOnFocus: boolean;
	isFocused: boolean;
};



const { messageCreatedAt, fullMessageCreatedAt } =
	useMessages();
const {
	isConversationUpdating,
	detachTeamMember,
	assignTeamMember
} = useConversations();
const { allItems } = useTeams();

const rootLink = ref<{ $el: HTMLLinkElement }>();

function focusItem(animate = true) {
	rootLink.value?.$el.focus({
		preventScroll: true
	});
	rootLink.value?.$el.scrollIntoView({
		block: 'nearest'
	});
}

const isUpdating = computed(() =>
	isConversationUpdating(props.conversation.id)
);

expose({ focusItem });

const isUnread = computed(() => {
	return props.conversation.unread_count > 0;
});

const assignActions = computed(() => {
	return [
		{ title: 'Unassigned', value: -1 },
		...allItems.value.map((item) => ({
			title: item.name,
			value: item.id
		}))
	];
});

function toggleAssign(id: number) {
	if (id === -1 && !props.conversation.assigned?.length) {
		return;
	}

	if (id === -1) {
		return detachTeamMember(
			props.conversation,
			props.conversation.assigned[0]
		);
	}

	const teamMember = allItems.value.find(
		(item) => item.id === id
	);

	if (!teamMember) {
		return;
	}

	return assignTeamMember(props.conversation, teamMember);
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: {
			name: 'ConversationDetails',
			params: {
				leadId: __props.conversation.id
			}
		},
    ref_key: "rootLink",
    ref: rootLink,
    class: _normalizeClass(["pr-8 pl-10 h-11 flex-shrink-0 border-0 border-b border-solid flex items-center justify-between relative py-2 transition group outline-none", [
			{
				'bg-gray-theme-300': __props.isFocused
			},
			{
				'bg-blue-400 bg-opacity-10':
					_unref(isUnread) && !__props.isFocused
			},
			__props.isOnFocus ? 'cursor-none' : 'cursor-pointer'
		]]),
    tabindex: "-1"
  }, {
    default: _withCtx(() => [
      (__props.conversation.unread_count)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Tooltip), {
          placement: "bottom",
          class: "w-44 overflow-hidden flex flex-shrink-0"
        }, {
          popper: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.conversation.lead.name), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["text-gray-theme-600 text-13 w-44 whitespace-nowrap overflow-hidden overflow-ellipsis flex-shrink-0", 
						_unref(isUnread)
							? 'font-medium'
							: 'font-light'
					])
            }, _toDisplayString(__props.conversation.lead.name), 3)
          ]),
          _: 1
        }),
        (__props.conversation.last_message)
          ? (_openBlock(), _createBlock(ShortMessage, {
              key: 0,
              class: "!text-13",
              message: __props.conversation.last_message,
              isUnread: 
						__props.conversation.unread_count > 0
					
            }, null, 8, ["message", "isUnread"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (__props.conversation.unread_count)
          ? (_openBlock(), _createBlock(UnreadMarker, {
              key: 0,
              class: "!h-4 !w-5.5 !rounded-lg",
              count: __props.conversation.unread_count
            }, null, 8, ["count"]))
          : _createCommentVNode("", true),
        (__props.conversation.last_message)
          ? (_openBlock(), _createBlock(_unref(Tooltip), {
              key: 1,
              placement: "bottom"
            }, {
              popper: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(fullMessageCreatedAt)(
							__props.conversation.last_message
								.created_at
						)), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(messageCreatedAt)(
							__props.conversation.last_message
								.created_at
						)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(DropdownWithTooltip), {
          tooltipTitle: 
					!__props.conversation.assigned ||
					!__props.conversation.assigned?.[0]
						? 'Assign to'
						: `Assigned to
								${__props.conversation.assigned?.[0]?.name}`
				,
          "dropdown-placement": 'bottom',
          openOnKey: 'A',
          inputTitle: "Assign to",
          withCheck: "",
          modelValue: 
					__props.conversation?.assigned?.[0]?.id || -1
				,
          isFocused: __props.isFocused,
          actions: _unref(assignActions),
          "onUpdate:modelValue": toggleAssign,
          disabled: _unref(isUpdating)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["text-gray-theme-400 flex items-center transition relative", {
						'opacity-50 hover:opacity-100':
							!__props.conversation.assigned?.length
					}])
            }, [
              (_unref(isUpdating))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_unref(UiLoader), { isSmall: "" })
                  ]))
                : _createCommentVNode("", true),
              (
							!__props.conversation.assigned?.length
						)
                ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                    key: 1,
                    name: "EmptyUserIcon",
                    class: "!h-4.5 !w-4.5"
                  }))
                : (_openBlock(), _createBlock(_unref(UiAvatar), {
                    key: 2,
                    withShadow: "",
                    class: "!h-4.5 !w-4.5 !text-xxs",
                    avatar: 
							__props.conversation.assigned[0]?.avatar
								?.path
						,
                    name: 
							__props.conversation.assigned[0]?.name
						
                  }, null, 8, ["avatar", "name"]))
            ], 2)
          ]),
          _: 1
        }, 8, ["tooltipTitle", "modelValue", "isFocused", "actions", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})